
export type DisablableElement = HTMLButtonElement | HTMLFieldSetElement | HTMLInputElement | HTMLOptGroupElement | HTMLOptionElement | HTMLSelectElement | HTMLTextAreaElement;

export function disabledWhen(element: DisablableElement, disableCondition: boolean) {

    const conditionChangeHandler = (isDisabled) => element.disabled = isDisabled;

    conditionChangeHandler(disableCondition);

    return {
        update: conditionChangeHandler
    }
}